import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../../services/auth.service';
import { TokenStorageService } from '../../services/token-storage.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate {

  private isLoggedIn: boolean;
  private observer$: Observable<boolean>;
  private userRole: string = '';

  constructor(private authService: AuthService,
    private tokenService: TokenStorageService,
    private router: Router
  ) {
    this.isLoggedIn = this.authService.isLoggedIn();
    this.observer$ = this.authService.loginChanged;
    this.observer$.subscribe((flag) => {
      this.isLoggedIn = flag;
    });
    this.getRole();
  }

  getRole(){
    const userConfig = this.tokenService.getUserConfig();
    this.userRole = userConfig.role?userConfig.role.toLowerCase():'';
  }
  //Follwed part of - https://medium.com/echohub/angular-role-based-routing-access-with-angular-guard-dbecaf6cd685
  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (this.isLoggedIn) {
      //Get the current user role so we can determine if the role has access to a specific route/page.
      this.getRole();
      if (this.userRole && next.data['role'] && next.data['role'].toLowerCase().indexOf(this.userRole) === -1) {
        this.router.navigate(['/']);
        return false;
      }
      return true;
    }
    else {
      this.authService.login();
      return false;
    }
  }
}
